module.exports = __webpack_public_path__ + "img/FerryDashboard.7183e192.svg";